/* @flow */
import * as React from 'react';

const ArrowBigVioletRight = props => (
  <svg width={24} height={16} viewBox="0 0 24 16" {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      fillRule="evenodd"
      d="M1.031,9 L20.111,9 L14.439,14.743 C14.136,15.017 14.437,15.478 14.721,15.771 C14.869,15.923 15.068,16 15.268,16 C15.452,16 15.637,15.935 15.781,15.803 L23.766,8.53 C23.826,8.47 23.836,8.436 23.857,8.407 C23.899,8.344 23.926,8.318 23.94,8.287 C23.964,8.224 23.967,8.179 23.975,8.135 C23.983,8.093 23.999,8.053 24,8.01 C23.999,7.946 23.983,7.906 23.975,7.864 C23.966,7.819 23.964,7.775 23.947,7.733 C23.926,7.681 23.899,7.656 23.881,7.626 C23.836,7.562 23.826,7.529 23.8,7.502 C23.77,7.476 15.782,0.197 15.782,0.197 C15.481,-0.077 15.007,-0.064 14.722,0.229 C14.438,0.521 14.137,0.982 14.439,1.257 L20.111,7 L1.031,7 C0.617,7 0,7.598 0,8 C0,8.401 0.617,9 1.031,9 Z"
    />
  </svg>
);

export default ArrowBigVioletRight;



// WEBPACK FOOTER //
// ./src/assets/images/icons/arrow-big-violet-right.js